import { Component, OnInit } from '@angular/core';
import { GlobalServices } from '../global.services';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(
    private globalService: GlobalServices
  ) { }

  ngOnInit(): void {
    if(this.globalService?.isBrowser){
      this.globalService?.hideHeader.next(false);
      this.globalService?.hideFooter.next(false);
    }
  }

}
